import {
  topMarketData,
  isMoreThan24Hours,
  groupByExchange,
} from "~/helpers/live-market";

export async function useLiveMarketData<T>(marketData = topMarketData) {
  const data = ref(null);

  const response = await $fetch(`/api/strapi/live-market`);
  const isExpired =
    !response || !response.jsonValue || isMoreThan24Hours(response.updatedAt);

  if (isExpired) {
    const res = await $fetch("/api/stock/fetchMarketData", {
      method: "POST",
      body: { symbols: marketData.map((c) => c.symbol) },
    });

    const jsonValue = groupByExchange(res, marketData);
    data.value = jsonValue;

    await $fetch(`/api/strapi/live-market`, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        data: { jsonValue },
      }),
    });
  } else {
    data.value = response.jsonValue;
  }

  return data;
}
